// data/items/seeds.js
// Farming seeds - used to plant crops and trees

// Crop seeds (obtained from grass patch or other sources)
// Sprites live in assets/icons/farming/crop_seeds/{id}.png (64x64)
const cropSeedSprite = (id) => ({ sheet: `assets/icons/farming/crop_seeds/${id}.png`, x: 0, y: 0, width: 64, height: 64 });
export const CROP_SEEDS = [
    { id: 'potato_seed', name: 'Potato Seed', color: '#d2691e', icon: '🌱', value: 1, sprite: cropSeedSprite('potato_seed') },
    { id: 'onion_seed', name: 'Onion Seed', color: '#dda0dd', icon: '🌱', value: 2, sprite: cropSeedSprite('onion_seed') },
    { id: 'cabbage_seed', name: 'Cabbage Seed', color: '#90ee90', icon: '🌱', value: 4, sprite: cropSeedSprite('cabbage_seed') },
    { id: 'tomato_seed', name: 'Tomato Seed', color: '#ff6347', icon: '🌱', value: 7, sprite: cropSeedSprite('tomato_seed') },
    { id: 'corn_seed', name: 'Corn Seed', color: '#f0e68c', icon: '🌱', value: 11, sprite: cropSeedSprite('corn_seed') },
    { id: 'strawberry_seed', name: 'Strawberry Seed', color: '#ff1493', icon: '🌱', value: 16, sprite: cropSeedSprite('strawberry_seed') },
    { id: 'watermelon_seed', name: 'Watermelon Seed', color: '#7cfc00', icon: '🌱', value: 22, sprite: cropSeedSprite('watermelon_seed') },
    { id: 'starbloom_seed', name: 'Starbloom Seed', color: '#ff00ff', icon: '🌱', value: 30, sprite: cropSeedSprite('starbloom_seed') },
    { id: 'kings_fruit_seed', name: "King's Fruit Seed", color: '#4b0082', icon: '🌱', value: 40, sprite: cropSeedSprite('kings_fruit_seed') }
];

// Tree seeds (higher tier, obtained from various sources)
export const TREE_SEEDS = [
    { id: 'ironwood_seed', name: 'Ironwood Seed', color: '#a0522d', icon: '🌰', value: 15 },
    { id: 'softbark_seed', name: 'Softbark Seed', color: '#9acd32', icon: '🌰', value: 30 },
    { id: 'goldleaf_seed', name: 'Goldleaf Seed', color: '#ff8c00', icon: '🌰', value: 50 },
    { id: 'redgrain_seed', name: 'Redgrain Seed', color: '#d2691e', icon: '🌰', value: 80 },
    { id: 'gravewood_seed', name: 'Gravewood Seed', color: '#228b22', icon: '🌰', value: 110 },
    { id: 'arcanewood_seed', name: 'Arcanewood Seed', color: '#9370db', icon: '🌰', value: 150 },
    // Ancient Seed - rare drop from Deep Roots talent, grows into Eldritch Sapling
    { id: 'ancient_seed', name: 'Ancient Seed', color: '#6b4423', icon: '🌌', value: 500 }
];

// Combined seeds export
export const SEEDS = [...CROP_SEEDS, ...TREE_SEEDS];

export default SEEDS;
